import { WizardStep } from './WizardContext';
import { ArtifactsStep } from './steps/ArtifactsStep/ArtifactsStep';
import { ReviewStep } from './steps/ReviewStep';
import { createArtifactConfigStep } from './steps/ArtifactConfigStep/ArtifactConfigStep';

/** One config step per artifact, so each is configured on its own screen. */
export function buildWizardSteps(artifactCount: number): Array<WizardStep> {
  return [
    ArtifactsStep,
    ...Array.from({ length: artifactCount }, (_, index) =>
      createArtifactConfigStep(index)
    ),
    ReviewStep,
  ];
}
